<template>
  <div id="appFooterStatic">
    <div class="titleFoo">SATE - Sindicato Argentino <br>de Técnicos Escénicos</div>
    <!-- <div
      class="conte-creditos"
      :style="'gridTemplateColumns: repeat(' + creditos.length + ', 1fr)'"
    >
      <div
        v-for="(grupo, index) in creditos"
        :key="index"
        class="columna-categorias"
      >
        <div class="categoria-title" v-html="grupo.cat"></div>
        <ul>
          <li
            v-for="(name, count) in grupo.name"
            :key="count"
            v-html="name"
          ></li>
        </ul>
      </div>
    </div> -->

    <!-- <div class="title-creditos">COMPARTÍ</div> -->
    <Redes
      :links="redes.links"
      :textoRedes="redes.txt"
      :hashtag="redes.hashtag"
    ></Redes>
    <Copyright />
  </div>
</template>

<script>
// import creditos from "@/data/creditos"
import Copyright from "./Copyright.vue"
import Redes from "./Redes"
// import { store } from './store/store.js'

export default {
  name: "FooterStatic",
  props: {
    creditos: {
      type: Array,
      default: () => []
    },
    redes: {
      type: Object,
      default: () => {}
    }
  },
  // data() {
  //   return {
  //     redes: {
  //       links: {
  //         linkFace: 'https://www.facebook.com/SATE.nacional?fref=ts',
  //         linkX: 'https://twitter.com/SATE_oficial',
  //         linkIG: 'https://www.instagram.com/sateargentina/',
  //         linkYouT: 'https://www.youtube.com/canalsate',
  //       },
  //       textoRedes:
  //         'SATE',
  //       hashtag: 'sate',
  //       isDark: false
  //     }
  //   }
  // },
  components: {
    Copyright,
    Redes
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/styles/_variables.scss";

#appFooterStatic {
  width: 100%;
  background-color: var(--sate);
  padding-bottom: 10px;
  color: white;
  margin-top: 150px;
  @media (max-width: var(--break-mobile)) {
    margin-top: 100px;
  }

  .titleFoo {
    text-align: center;
    font-size: 17px;
    font-family: var(--sans);
    font-weight: 700;
    line-height: 50px;
    padding-top: 20px;
    color: #fff;
    margin: auto;
    line-height: 1.2;
    // border-bottom: 1px solid #fff;
    // max-width: 170px;
    br{
      display: none;
      @media screen and (max-width: 400px) {
        display: inline;
      }
    }
  }

  .conte-creditos {
    display: grid;
    // width: 100%;
    max-width: 800px;
    justify-content: center;
    margin: 0 auto;
    flex-wrap: wrap;

    div.columna-categorias {
      padding: 0;
      text-align: center;

      div.categoria-title {
        font-family: var(--suecaslabbold);
        margin-top: 25px;
        margin-bottom: 8px;
      }

      ul {
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
          line-height: 1.2;
        }
      }
    }
  }

  div#copyright {
    text-align: center;
    margin: 20px 0;
    padding: 20px;
    // text-transform: uppercase;
    line-height: 1.4;
    font-family: var(--sans);
    font-weight: 500;
     @media screen and (max-width: 600px) {
        margin: 0;
      }
  }
}
</style>
